module.exports = __webpack_public_path__ + "img/qrCode1.fd1f85ec.png";